import { render, staticRenderFns } from "./ModelIconCSS.vue?vue&type=template&id=5c6f32f1&scoped=true&"
import script from "./ModelIconCSS.vue?vue&type=script&lang=js&"
export * from "./ModelIconCSS.vue?vue&type=script&lang=js&"
import style0 from "./ModelIconCSS.vue?vue&type=style&index=0&id=5c6f32f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f32f1",
  null
  
)

export default component.exports